<template>
  <div>
    <el-dialog :title="title" :visible.sync="showOrderDelivery" :before-close="handleClose" width="400px">
      <span>
        <el-form ref="ruleForm" :model="ruleForm" label-width="120px" :rules="rules">
        <el-form-item label="物流公司：" prop="bagId">
          <el-select v-model="ruleForm.bagId" filterable placeholder="请选择物流公司"
                     clearable
                     style="width: 100%"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号：" prop="bagNo">
          <el-input placeholder="请输入快递单号" clearable v-model="ruleForm.bagNo" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import http from '../../common/http'

export default {
  props: {
    title: {
      type: String
    },
    isShow: {
      type: Boolean
    },
    orderId: {},
    bagNo: {},
    bagId: {}
  },
  data () {
    return {
      showOrderDelivery: false,
      ruleForm: {},
      rules: {
        bagId: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        bagNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' }
        ]
      },
      logisticsList: []
    }
  },
  mounted () {
    this.$set(this.ruleForm, 'orderId', this.orderId)
    this.$set(this.ruleForm, 'bagNo', this.bagNo)
    this.bagId && this.$set(this.ruleForm, 'bagId', Number(this.bagId))
    this.showOrderDelivery = this.isShow
    this.queryExpress()
  },
  methods: {
    handleClose () {
      this.showOrderDelivery = false
      this.$emit('closeDialog', this.showOrderDelivery)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title === '发货') {
            this.$set(this.ruleForm, 'orderStatus', 6)
          }
          this.updateOrder()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateOrder () {
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/updateOrder",
        method: "put",
        data: {
          ...that.ruleForm
        }
      };
      axios(options)
        .then((response) => {
          that.$notify({
            title: '成功',
            message: response.data.message,
            type: 'success'
          })
          that.handleClose()
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    },
    queryExpress () {
      let that = this;
      const options = {
        url: "distribution/B2cExpressController/queryExpress",
        method: "get",
        params: {
          current: 1,
          size: 9999
        }
      };
      axios(options)
        .then((response) => {
          if (response.data.code == 200) {
            that.logisticsList = response.data.data.records
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/OrderManage/orderDelivery.vue